function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 10,
  height: 5,
  rx: 1,
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.5,
  y: 7,
  width: 10,
  height: 5,
  rx: 1,
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.2,
  y: 14,
  width: 10,
  height: 5,
  rx: 1,
  fill: "#6F62FF"
});

var SvgMultipleChoice = function SvgMultipleChoice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMultipleChoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multiple_choice.a30964e7.svg";
export { ForwardRef as ReactComponent };